import React from "react";

const MAP = {
  New: "bg-slate-100 text-slate-800 border-slate-200 dark:bg-slate-800/40 dark:text-slate-200 dark:border-slate-700",
  Contacted: "bg-cyan-100 text-cyan-900 border-cyan-200 dark:bg-cyan-950/30 dark:text-cyan-200 dark:border-cyan-900",
  Replied: "bg-amber-100 text-amber-900 border-amber-200 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-900",
  Interested: "bg-emerald-100 text-emerald-900 border-emerald-200 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-900",
  Won: "bg-emerald-200 text-emerald-950 border-emerald-300 dark:bg-emerald-900/50 dark:text-emerald-100 dark:border-emerald-800",
  Lost: "bg-rose-100 text-rose-900 border-rose-200 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-900",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${MAP[status] || MAP.New}`}
  >
    {status}
  </span>
);
